export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14284.1ab99446.jpg";